/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { mergeAll, pipe, map } from 'ramda';
import { connect } from 'react-redux';
import { compose, lifecycle, branch, renderComponent } from 'recompose';
import { t } from '../../../../../modules/infra/i18n';

import StatusList from './StatusList';
import { fetchShopBarbers } from '../../actions';
import { getShop } from '../../../shops/reducers';
import withToggle from '../../../../common/hoc/withToggle';
import { getBarberUsersForShop, getShopUsers } from '../../selectors';
import { findBarberName } from '../../../../common/helpers/shops';
import { fetchShop } from '../../../shops/actions';

const mapStateToProps = (state, props) => ({
  barberUsers: getBarberUsersForShop(state, props.shopId),
  shopUsers: pipe(getShop, getShopUsers)(state, props.shopId),
  shop: getShop(state, props.shopId),
});

const mapDispatchToProps = {
  fetchShopBarbers,
  fetchShop,
};

const mapNames = shop => (user) => {
  const data = { ...user, name: shop.name };

  if (user.brand) {
    data.name = user.brand.name;
  }

  if (user.barbers) {
    data.name = findBarberName(user.barbers);
  }

  return data;
};

const mergeProps = (...propsSources) => {
  const props = mergeAll(propsSources);
  props.users = map(
    mapNames(props.shop),
    [...props.shopUsers, ...props.barberUsers].filter(Boolean)
  );

  return props;
};

const enhance = compose(
  withToggle('busy', true),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  lifecycle({
    componentWillMount() {
      if (this.props.barberUsers) {
        this.props.busyOff();
        return;
      }

      Promise.all([
        this.props.fetchShopBarbers(this.props.shopId),
        this.props.fetchShop(this.props.shopId),
      ])
        .then(this.props.busyOff)
        .catch(this.props.busyOff);
    },
  }),
  branch(
    props => props.busyIsOn,
    renderComponent(() => <StatusList>{t('admin:barbers_list.loading')}</StatusList>)
  ),
  branch(
    props => !props.busyIsOn && !props.users.length,
    renderComponent(() => <StatusList>{t('admin:barbers_list.no_users_found')}</StatusList>)
  ),
);

export default enhance;
